import fetch from '@/service/fetch';

export function getTopNoticeList() {
  return fetch('/api/portal/msg/announcement/index-top');
}

export function getHomeData() {
  return fetch('/api/portal/act/main-index');
}

export function getHomeArticle() {
  return fetch('/api/portal/art/index');
}

export function getNewsList(params) {
  return fetch('/api/portal/art/news/page', {
    data: params
  })
}
